exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-wave[data-v-38171e1c]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;position:relative;overflow:hidden;line-height:normal}.btn-wave .ripple[data-v-38171e1c]{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0}", ""]);

// exports
